import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
//routes
import { NotFoundRoute } from './routes/NotFoundRoute';
import HandleCallbackResetPassword from '../Containers/HandleCallbackForResetPassword/HandleCallbackForResetPassword';
import { asyncComponent } from '../HOC/withAsyncLoaded';
import CheckIn from '../Containers/CheckIn';
import { browserHistory } from '../../Store';
import { SignInEntry } from '../Containers/Authentication/SignIn/SignInEntry';
import { SignUpEntry } from '../Containers/Authentication/SignUp/SignUpEntry';
import { CheckEmail } from '../Containers/Authentication/ResetPassword/CheckEmail';
import { SignIn } from '../Containers/Authentication/SignIn';
import { RegisterGym } from '../Containers/Authentication/SignUp/RegisterGym';
import { RegisterUser } from '../Containers/Authentication/SignUp/RegisterUser';
import { ResetPasswordEnterEmailPage } from '../Containers/Authentication/ResetPassword/EnterEmail';
import { UpdatePassword } from '../Containers/Authentication/ResetPassword/UpdatePassword';
import { PasswordUpdated } from '../Containers/Authentication/ResetPassword/PasswordUpdated';
import GymAdminPanel from '../Containers/GymAdminPanel';
import WorkoutPlan from '../Containers/WorkoutPlan';
import { PlannedWorkoutsPage } from '../Containers/PlannedWorkouts';

const RootProfilePage = asyncComponent(() => {
    return import('../Containers/RootProfilePage').then(module => module.default);
});

export const App = () => (
    <Router browserHistory={browserHistory}>
        <Switch>
            <Route exact path={'/'} component={SignInEntry} />
            <Route exact path={'/sign-in'} component={SignIn} />
            <Route exact path={'/sign-up'} component={SignUpEntry} />
            <Route exact path={'/sign-up-gym'} component={RegisterGym} />
            <Route exact path={'/sign-up-email'} component={RegisterUser} />
            <Route exact path={'/reset-password'} component={ResetPasswordEnterEmailPage} />
            <Route exact path={'/check-email'} component={CheckEmail} />
            <Route exact path={'/reset-password/callback'} component={HandleCallbackResetPassword} />
            <Route exact path={'/update-password'} component={UpdatePassword} />
            <Route exact path={'/password-updated'} component={PasswordUpdated} />

            <Route exact path={'/check-in'} component={CheckIn} />
            <Route exact path={`/planner`} component={WorkoutPlan} />
            <Route path={`/planned`} component={PlannedWorkoutsPage} />
            <Route path={'/gym-admin'} component={GymAdminPanel} />
            <Route path={'/:profileId'} component={RootProfilePage} />
            <NotFoundRoute />
        </Switch>
    </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/UI/App/App.js